import { useStripe as _useStripe } from '@stripe/react-stripe-js'

import {
	PaymentError,
	type PaymentService,
} from '~/domains/payments/providers/payment.provider'

export const useStripe = (): PaymentService => {
	const stripe = _useStripe()

	return {
		async confirmCardPayment(continuationKey) {
			const resStripe = await stripe!.confirmCardPayment(continuationKey)

			if (resStripe.error) {
				return {
					error: new PaymentError(resStripe.error),
				}
			}

			return {
				paymentIntent: {
					_res: resStripe.paymentIntent,
					id: resStripe.paymentIntent.id,
				},
			}
		},

		async createPaymentMethod(continuationKey, options) {
			const resStripe = await stripe!.confirmCardSetup(continuationKey, {
				payment_method: {
					card: options.cardElement,
					billing_details: options.billingDetails,
					metadata: options.metadata,
				},
			})

			if (resStripe?.error) {
				return {
					error: new PaymentError(resStripe.error),
				}
			}

			return {
				setupIntent: {
					_res: resStripe?.setupIntent,
					id: resStripe.setupIntent.id,
				},
			}
		},
	}
}
